/* eslint-disable no-unused-vars */
import React from "react";
import Hero from "./HeroArea";
import Feature from "./FeatureArea";
import About from "./AboutArea";
import Service from "./ServiceArea";
import Newsletter from "./NewsletterArea";
import ChooseUs from "./ChooseArea";
import FunFact from "./FunFactArea";
import Team from "./TeamArea";
import Cases from "./CasesArea";
import Testimonial from "./TestimonialArea";
import Blog from "./BlogArea";
import VlogArea from "./VlogArea";

const HomeFourMain = () => {
  return (
    <main>
      <Hero />
      <Feature />
      <Service />
      {/* <About /> */}
      <Team />
      {/* <Newsletter /> */}
      {/* <ChooseUs /> */}
      <FunFact />

      <Cases />
      <Testimonial />
      <Blog />
      <VlogArea />
    </main>
  );
};

export default HomeFourMain;
